<template>
  <form class="u-form" @submit.prevent="joinSquad">
    <div v-if="joined">
      <div class="u-richtext u-mb2">
        <p>Your name and contact information has been shared with the squad leader, who will contact you soon.</p>
      </div>
      <div class="u-form-actions u-mt4">
        <button @click="cancel" type="button" class="Button Button--outline">Done</button>
      </div>
    </div>

    <div v-else>
      <div class="u-richtext u-mb2">
        <p>Let the leader of {{ squad.name }} that you're interested in joining the squad.</p>
      </div>

      <div class="u-mb2 u-form-shortWrapper">
        <label for="join-squad-form-name">
          Your Name
          <span data-error v-show="errors.has('name')">{{ errors.first('name') }}</span>
        </label>
        <input type="text" name="name" id="join-squad-form-name" placeholder="Provide your name" v-model="name" v-validate="{ required: true }"/>
      </div>

      <div class="u-mb2 u-form-shortWrapper">
        <label for="join-squad-form-email">
          Email
          <span data-error v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </label>
        <input type="email" name="email" id="join-squad-form-email" placeholder="Provide an email address" v-model="email" v-validate="{ required: true, email: true }"/>
      </div>

      <div class="u-form-actions u-mt4">
        <button type="submit" class="Button Button--square">Join {{ squad.name }}</button>
        <button @click="cancel" type="button" class="Button Button--outline">Cancel</button>
      </div>
    </div>
  </form>
</template>

<script>
import Vue from 'vue/dist/vue.common.js';
import VeeValidate from 'vee-validate';
import SquadsService from "../services/squads";
import EventBus from '../instances/event-bus';

Vue.use(VeeValidate);

export default {
  data() {
    return {
      name: '',
      email: ''
    }
  },

  computed: {
    joined() {
      return this.$store.state.squadSearch.joined;
    },
    squad() {
      return this.$store.state.squadSearch.squad;
    },
    valid() {
      if ( this.fields.email.valid && this.fields.name.valid ) {
        return true;
      }
      return false;
    }
  },

  methods: {
    joinSquad() {
      if ( this.valid ) {
        SquadsService.join(this.squad, { email: this.email, name: this.name }).then(response => {
          this.$store.commit('squadSearch/setJoined', true)
        });
      }
    },
    cancel() {
      EventBus.$emit('closeModal');
    },
  }
}
</script>



// WEBPACK FOOTER //
// join-squad.vue?2c9d83cb